import './AddPhoto.scss';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import Attachment from '../../api/controllers/Attachment/Attachment';
import Error from '../Error/Error';
import LoadingSpinner from '../LoadingSpinner/LoadingSpinner';
import Button from '../Button/Button';

// Common AddPhoto Component
const AddPhoto = ({ edit, photo, modelName, movementId, setModalOpen, refetchPhotos }) => {
  const [error, setError] = useState();
  const [types, setTypes] = useState([]);
  const [file, setFile] = useState(null);
  const [type, setType] = useState();
  const [content, setContent] = useState('');
  const [firstOption, setFirstOption] = useState();
  const [loading, setLoading] = useState();

  const createPhoto = () => {
    const params = {
      parentType: modelName,
      parentId: movementId,
      classification: type,
      attachment: file,
      description: content,
    };
    const paramsWithoutFile = {
      parentType: modelName,
      parentId: movementId,
      classification: type,
      description: content,
    };
    setLoading(true);
    Attachment.create(file ? params : paramsWithoutFile)
      .then(() => {
        refetchPhotos();
        setModalOpen(false);
        setLoading(false);
      })
      .catch(e => {
        setLoading(false);
        setError(e.errors || e.error);
      });
  };

  const updatePhoto = () => {
    const params = {
      parentType: modelName,
      parentId: movementId,
      classification: type,
      attachment: file,
      description: content,
    };
    setLoading(true);
    Attachment.update(photo.id, params)
      .then(() => {
        refetchPhotos();
        setModalOpen(false);
        setLoading(false);
      })
      .catch(e => {
        setLoading(false);
        setError(e.errors || e.error);
      });
  };

  const getTypes = () => {
    setLoading(true);
    Attachment.getTypes()
      .then(response => {
        setTypes(response);
        if (!edit) {
          setType(response[0]);
        }
        setLoading(false);
      })
      .catch(e => {
        setLoading(false);
        setError(e.errors || e.error);
      });
  };

  useEffect(() => {
    getTypes();
    if (edit) {
      setFile(photo.file);
      setFirstOption(photo.classification);
      setType(photo.classification);
      setContent(photo.description);
    }
  }, []);

  return (
    <div className="add_photo_container">
      {loading && <LoadingSpinner />}
      {error && (
        <Error
          errorMessages={error}
          type={'error'}
          errorTitle={
            Array.isArray(error)
              ? `${error.length} error${error.length > 1 ? 's' : ''} occurred: `
              : ''
          }
        />
      )}
      <div className="add_photo_row">
        <div className="add_photo_file">
          <div className="label_block">Image</div>
          {edit ? (
            <div className="file_name">{photo.attachmentFileName}</div>
          ) : (
            <input
              capture="environment"
              accept="image/*"
              type={'file'}
              className="file_input"
              id="attached_photo"
              name="attached_photo"
              onChange={e => setFile(e.target.files[0])}
              data-testid="input_image_capture"
            />
          )}
        </div>
        <div className="add_photo_type">
          <div className="label_block">Type</div>
          <select onChange={e => setType(e.target.value)} data-testid="photo_type_selector">
            {edit && firstOption != '' && (
              <option value={firstOption} selected disabled hidden>
                {firstOption?.charAt(0)?.toUpperCase() +
                  firstOption?.replaceAll('_', ' ').substring(1)?.toLowerCase()}
              </option>
            )}
            {types?.map(type => (
              <option key={type} value={type} data-testid={`photo_type_option_${type}`}>
                {type?.charAt(0)?.toUpperCase() +
                  type?.replaceAll('_', ' ')?.substring(1)?.toLowerCase()}
              </option>
            ))}
          </select>
        </div>
      </div>
      <textarea
        data-testid="photo_content_textarea"
        className="add_photo_content"
        value={content}
        onChange={e => setContent(e.target.value)}
      />
      <Button
        className="add_photo_button"
        onClick={edit ? () => updatePhoto() : () => createPhoto()}
        label={`${edit ? 'Update' : 'Upload'} Photo`}
      />
    </div>
  );
};

AddPhoto.propTypes = {
  edit: PropTypes.bool,
  photo: PropTypes.object,
  modelName: PropTypes.string,
  movementId: PropTypes.number,
  refetchPhotos: PropTypes.func,
  setModalOpen: PropTypes.func,
};

export default AddPhoto;
